import { render } from "./EventRequests.vue?vue&type=template&id=6f65c34a"
import script from "./EventRequests.vue?vue&type=script&lang=js"
export * from "./EventRequests.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__